import localConf from '../../local-conf.js';
import matomo from './code.js';

interface UniMatomoOptions {
  matomo: any;
  trackerUrl: string;
  options?:
    | {
        autoTrackPage?: boolean | undefined;
        enableLog?: boolean | undefined;
        pageScheme?: string | undefined;
        pageTitles?: any;
      }
    | undefined;
  // siteId: string;
}

class UniMatomo {
  private matomoInstace;
  private trackerUrl;
  // private siteId;
  private opts;

  constructor(options: UniMatomoOptions) {
    this.matomoInstace = options.matomo;
    this.trackerUrl = options.trackerUrl;
    this.opts = options.options;
  }

  public init(siteId: string) {
    this.matomoInstace.initTracker(this.trackerUrl, siteId, this.opts);
  }
  /**
   * 自定义事件追踪
   * eg: trackEvent('商城', '商品分享', '商品名称', 1)
   * @param type - 事件类型
   * @param action - 事件行为
   * @param name - 具体目标名称
   * @param value - 事件行为的数值型参数
   */
  public trackEvent(type: string, action: string, name: string, value: number) {
    this.matomoInstace.tracker?.trackEvent(type, action, name, value);
  }

  /**
   * 自定义页面追踪
   * @param title - 页面标题
   * @param path - 页面路径
   */
  public trackPageView(title: string, path: string) {
    this.matomoInstace.tracker?.trackPageView(title, path);
  }

  /**
   * 用户绑定
   * @param id - 用户标识 ｜ userId or email
   */
  public bindUser(id: string) {
    this.matomoInstace.tracker?.setUserId(id);
  }

  public getMatomo() {
    return this.matomoInstace;
  }

  public getUserId() {
    const userId = this.matomoInstace.tracker.getCookie(
      this.matomoInstace.tracker?.getCookieName('user_id')
    );
    return userId;
  }

  public setUserId(id: string) {
    this.matomoInstace.tracker?.setCookie(this.matomoInstace.tracker.getCookieName('user_id'), id);
  }

  // 拿到pkid
  public getPkId() {
    const pkid = this.matomoInstace.tracker.getCookie(
      this.matomoInstace.tracker?.getCookieName('id')
    );
    return pkid;
  }

  // 设置pkid
  public setPkId(id: string) {
    this.matomoInstace.tracker?.setCookie(this.matomoInstace.tracker.getCookieName('id'), id);
  }

  public checkUserId() {
    const userId = this.getUserId();
    return typeof userId === 'string';
  }
}

const uniMatomo = new UniMatomo({
  matomo,
  trackerUrl: `${localConf.motamoHost}/matomo.php`,
  options: {
    enableLog: true,
  },
  // siteId: '3',
});

export default uniMatomo;
